




import 'survey-analytics/survey.analytics.min.css';
import { defineComponent, onMounted } from '@vue/composition-api';
import { Model } from 'survey-core';
import { IVisualizationPanelOptions, VisualizationPanel } from 'survey-analytics';
import { getSurveysStore } from '@front-app/modules/surveys/store/SurveysStore';

const vizPanelOptions: IVisualizationPanelOptions = {
	allowHideQuestions: false,
	allowDynamicLayout: false,
};

export default defineComponent({
	props: {
		groupId: {
			type: String,
			required: true,
		},
		surveyId: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const SurveysStore = getSurveysStore();
		onMounted(async () => {
			const results = await SurveysStore.fetchSurveyResponses(props.surveyId);

			if (results.length > 0) {
				const surveyJson = JSON.parse(results[0].originalSurveyContent);
				const surveyResults = results.map(({ answersContent }) => JSON.parse(answersContent));

				const survey = new Model(surveyJson);
				const vizPanel = new VisualizationPanel(
					survey.getAllQuestions(),
					surveyResults,
					vizPanelOptions,
				);
				vizPanel.showHeader = false;
				const el = document.getElementById('survey-visualizer');
				if (el) {
					vizPanel.render(el);
				}
			}
		});
		return {};
	},
});
